import { useTranslations } from "next-intl";
import { FC, useEffect, useState } from "react";

import { searchCategoriesByIDs } from "@/actions/search";
import BeedromFilters from "@/components/GuidedToolLauncher/BeedromFilters";
import { CommercetoolsCategory, GuidedToolSlideProps, Media, PRODUCT_TYPE } from "@/types";

import EditorialSlide from "./EditorialSlide";
import { useGuidedToolContext } from "./GuidedToolProvider";
import RangeSelector from "./RangeSelector";

const FilterSlide: FC<GuidedToolSlideProps> = ({ slide }) => {
  const t = useTranslations();
  const { filters } = useGuidedToolContext();
  const [locations, setLocations] = useState<CommercetoolsCategory[]>([]);

  // effect for locations filter
  // can be moved in the contentful component so no fetch occur here, resulting in an improved experience
  useEffect(() => {
    const fetchData = async () => {
      if (slide.locations) {
        const response = await searchCategoriesByIDs(slide.locations);
        setLocations(response);
      }
    };

    if (slide.filterType == "location") {
      fetchData();
    }
  }, [slide.filterType, slide.locations]);

  if (Object.keys(filters).length == 0 || (slide.filterType == "location" && locations.length == 0)) {
    return <></>;
  }

  switch (slide.filterType) {
    case "bedrooms":
      return <BeedromFilters options={filters[slide.filterType]} slideId={slide.id} />;
    case "price range":
      return (
        <RangeSelector
          slide={{
            ...slide,
            rangeMin: filters["minimumUnitPrice"][0].value as number,
            rangeMax: (filters["maximumUnitPrice"].slice(-1)[0]?.value || filters["minimumUnitPrice"].slice(-1)[0]?.value) as number,
          }}
          isPriceRange
        />
      );
    case "location":
      return (
        <EditorialSlide
          slide={{
            ...slide,
            variant: "multi",
            options: locations.map((location) => ({
              id: location.id,
              title: location.name,
              description: location.ancestors?.[0].name,
              image: slide.filtersWithImage?.[location.id]
                ? ({ title: location.name, url: slide.filtersWithImage[location.id].url } as Media)
                : undefined,
            })),
          }}
        />
      );
    case PRODUCT_TYPE.PROPERTY_TYPE:
    case "status":
      return (
        <EditorialSlide
          slide={{
            ...slide,
            variant: "multi",
            options: filters[slide.filterType].map((filter, index) => ({
              id: `${index}`,
              title: `${filter.value}`,
              image: slide.filtersWithImage?.[filter.value]
                ? ({ title: `${filter.value}`, url: slide.filtersWithImage[filter.value].url } as Media)
                : undefined,
            })),
          }}
        />
      );
    case "isFurnished":
      return (
        <EditorialSlide
          slide={{
            ...slide,
            variant: "single",
            options: [
              {
                id: `yes-${slide.id}`,
                title: t("label.yes"),
                description: t("label.yesDesc"),
              },
              {
                id: `no-${slide.id}`,
                title: t("label.no"),
                description: t("label.noDesc"),
              },
            ],
          }}
        />
      );
    default:
      return <></>;
  }
};
export default FilterSlide;
